import React from 'react';

import HomeHeader from './home-header';

export default React.memo(HomeHeader);
